export default __webpack_public_path__ + "static/05-15661288d3afd34ed5f420475d46aa76.jpg";